import React from 'react'

import { useEntity } from '@uswitch/ev-utils/lib/context/selectors'

/**
 * @typedef {Function} ContentfulStateToProps
 * A function that accepts a Contentful module from the state and maps the data into an object of
 * component properties.
 *
 * @param {Object} state - The Redux state.
 * @param {Object} props - The properties to map.
 * @returns {Object}
 */

/**
 * A connect-entity function. This function takes a mapStateToProps function with the same
 * signature as the Redux connect function. It reads the `id` property off of the component to know
 * what module to fetch from the contentful state before mapping the contentful module state over
 * the supplied mapStateToProps function.
 *
 * The result of this function is a contentful connected React component.
 *
 * @param {ContentfulStateToProps} [mapStateToProps] - The contentful state map function.
 * @returns {Function}
 */

export default f => C => ({ entity, entityId }) => {
  console.log('WRAPPED CONNECT', entity || { id: entityId })
  const props = useEntity(entity || { id: entityId })

  return <C {...props} />
}

/**
 * A connect-entity function. This function takes a mapStateToProps function with the same
 * signature as the Redux connect function. It reads the `id` property off of the component to know
 * what module to fetch from the contentful state before mapping the contentful module state over
 * the supplied mapStateToProps function.
 *
 * The result of this function is a contentful connected React component.
 *
 * @param {ContentfulStateToProps} [mapStateToProps] - The contentful state map function.
 * @returns {Function}
 */

export const connectEntityWithProps = f => C => ({ entity, entityId, ...restProps }) => {
  console.log('WRAPPED CONNECT W/PROPS', entity || { id: entityId })
  const props = useEntity(entity || { id: entityId })

  return <C {...restProps} {...props} />
}
